import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CellDoubleClickedEvent, GridOptions, GridReadyEvent } from 'ag-grid';
import { IBackGroundCheck } from '../../../../core/interfaces/background-check.interface';
import { BackgroundCheckService } from '../../../../services/background-check.service';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { OnDemandDriversService } from '../../../on-demand-drivers/on-demand-drivers.service';
import { DriverApplicationStatusEnum } from '../../../../core/enums/driver.enum';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';
import { DriverBackgroundCheckStateService } from '../../../../utils/driver-background-check/driver-background-check-state.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-background-checks',
  templateUrl: './background-checks.component.html',
  styleUrls: ['./background-checks.component.scss'],
  providers: [DriverBackgroundCheckStateService]
})
export class BackgroundChecksComponent implements OnInit, OnDestroy {

  showInactive = false;
  public tabActive = 'NewApplicants';
  public totalNewApplicants = 0;
  public totalRenewals = 0;
  public totalPending = 0;
  public totalConsider = 0;
  public title : string;
  public applicationStatusId : number;
  gridOptions: GridOptions;
  gridData: IBackGroundCheck[] = [];
  selectedData: any;
  searchGridForm;
  public showLoading = false;
  @ViewChild('modalStatus') private modalStatus: T2CardComponent;
  protected rejReasonList: any[];
  public formRejected: FormGroup;

  private subscriptions: Subscription[] = [];

  constructor(
    private backgroundCheckService: BackgroundCheckService,
    private sweetAlertHelper: SweetAlertHelper,
    private _loading: T2LoadingService,
    protected onDemandDriverService: OnDemandDriversService,
    private _fb: FormBuilder,
    private driverBackgroundCheckService: DriverBackgroundCheckStateService) {
    this.createGrid();
    this.createForm();
    this.driverBackgroundCheckService.setRunCheckVisible(false);
    this.driverBackgroundCheckService.setReportSelectorVisible(false);
  }

  ngOnInit() {
    this.getRejectedStatus();
  }

  private createForm(): void {
    this.formRejected = this._fb.group({
      rejectionstatusid: ['', [Validators.required]]
    });
  }

  getRejectedStatus(): void {
    this.subscriptions.push(this.onDemandDriverService.getRejectedReason()
      .subscribe({
        next: (data: any) => { this.rejReasonList = data; }
      }));
  }

  createGrid() {
    this.gridOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'single',
      sortingOrder: ['desc', 'asc', null],
      columnDefs: [
        {
          headerName: 'Id',
          field: 'id'
        },
        {
          headerName: 'Name',
          field: 'name'
        },
        {
          headerName: 'Phone',
          field: 'phone'
        },
        {
          headerName: 'Email',
          field: 'email'
        },
        {
          headerName: 'Company',
          field: 'companyname'
        },
        {
          headerName: 'Creation date',
          field: 'creationdate'
        },
        {
          headerName: 'Status',
          field: 'description'
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event) {
          this.getBackgroundChecks();
          this.gridOptions.api.sizeColumnsToFit();
        }
      },
      onCellDoubleClicked: (event: CellDoubleClickedEvent) => {
        if (event && event.data) {
          this.title = event.data.name;
          this.selectedData = event.data.id;
          this.applicationStatusId = event.data.applicationstatusid;
          this.driverBackgroundCheckService.setDriverId(event.data.id);
        }
      },
    };
  }

  getBackgroundChecks(loadCounts : boolean = true) {

    this.showLoading = true;
    this._loading.show();

    const getBackgroundChecksList$ = this.backgroundCheckService.getBackgroundChecks(this.tabActive, this.showInactive, this.searchGridForm);
    const getBackgroundChecksCount$ = this.backgroundCheckService.getBackgroundChecksCounts(this.showInactive, this.searchGridForm);
    const arrayServices = [getBackgroundChecksList$];

    if (loadCounts) {
      arrayServices.push(getBackgroundChecksCount$)
    }

    this.subscriptions.push(Observable.forkJoin(arrayServices)
      .pipe(
        finalize(() => {
          this.showLoading = false;
          this._loading.hiden();
        })
      )
      .subscribe(([result1, result2]) => {
        if (result1) {
          this.gridData = result1;
        }

        if (result2) {
          this.totalNewApplicants = result2.totalnewapplicants;
          this.totalRenewals = result2.totalrenewals;
          this.totalPending = result2.totalpending;
          this.totalConsider = result2.totalconsider;
        }
      },
      (error) => {
        this.sweetAlertHelper.captureException(error);
      }));
  }

  public onChangeTabs(type: string): void {
    this.tabActive = type;
    this.getBackgroundChecks(false)
    this.selectedData = null;
  }

  onGetDisabled(event) {
    this.showInactive = event;
    this.getBackgroundChecks();
  }

  public keydown(event) {
    if (event.key === 'Enter') {
      this.getBackgroundChecks();
    }
  }

  getShowViewByStatus(status :string): boolean {
    return this.tabActive === status && this.selectedData;
  }

  onCloseForm() {
    this.selectedData = undefined;
    this.getBackgroundChecks()
  }

  approved() {

    let data = {
      DriverId: this.selectedData,
      StatusType: 'Approve'
    };
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Are you sure?',
        text: 'You want to approve this driver?',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'No',
        cancelButtonText: 'Yes',
      })
      .then((result) => {
        if (result.dismiss === swal.DismissReason.cancel) {
          this._loading.show('Loading Background Check');
          this.subscriptions.push(
          this.backgroundCheckService
            .changeApplicationStatus(data)
            .finally(() => {
              this._loading.hiden();
            })
            .subscribe({
              next: (resp) => {
                if (resp && resp.success) {
                  this.sweetAlertHelper
                    .createCustomAlert({
                      title: 'success',
                      text: `${resp.message}`,
                      type: 'success',
                    })
                    .then(() => {
                      this.onCloseForm();
                    });
                }
              },
              error: (error) => {
                this.sweetAlertHelper.captureException(error);
              }
            }
          ));
        }
      });
  }

  get isDrugTest(): boolean {
    return  this.applicationStatusId && this.applicationStatusId == DriverApplicationStatusEnum.DrugTest;
  }

  rejected() {
    this.modalStatus.open();
  }

  rejectedSave() {

    const dataForm = this.formRejected.getRawValue();

    let data = {
      DriverId: this.selectedData,
      StatusType: 'Rejected',
      RejectionStatusId: dataForm.rejectionstatusid
    };

    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Are you sure?',
        text: 'You want to rejected this driver?',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'No',
        cancelButtonText: 'Yes',
      })
      .then((result) => {
        if (result.dismiss === swal.DismissReason.cancel) {
          this._loading.show('Loading Background Check');
          this.showLoading = true;
          this.subscriptions.push(
          this.backgroundCheckService
            .changeApplicationStatus(data)
            .finally(() => {
              this.showLoading = false;
              this._loading.hiden();
            })
            .subscribe({
              next: (resp) => {
                if (resp && resp.success) {
                  this.sweetAlertHelper
                    .createCustomAlert({
                      title: 'success',
                      text: `${resp.message}`,
                      type: 'success',
                    })
                    .then(() => {
                      this.formRejected.reset();
                      this.modalStatus.close();
                      this.onCloseForm();
                    });
                }
              },
              error: (error) => {
                this.sweetAlertHelper.captureException(error);
              }
            }
          ));
        }
      });
  }

  getClassButtonActive(type : string): string {
    return  this.tabActive === type ? 'active btn-primary' : '';
  }

  getClassButtonDanger(type : string): string {
    return  this.tabActive != type ? 'color-danger' : '';
  }

  get getStatusRenewals(): boolean {
    return this.getShowViewByStatus('Renewals') ? true : false;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/administration/fleet/background-checks/background-checks.component.ts